import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGoldMedal: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconGoldMedal"><Path d="M16.5 23.2812L12 22.0303L7.5 23.2812V18.1182C8.83945 18.84 10.3718 19.25 12 19.25C13.6282 19.25 15.1605 18.84 16.5 18.1182V23.2812Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M12 1.5C16.5563 1.5 20.25 5.19365 20.25 9.75C20.25 14.3063 16.5563 18 12 18C7.44365 18 3.75 14.3063 3.75 9.75C3.75 5.19365 7.44365 1.5 12 1.5ZM9.27344 6.97656V8.64844L11.0625 7.55469H11.1094V13.75H13.0391V5.75H11.2461L9.27344 6.97656Z" fill="currentColor"/></CentralIconBase>;
});

export default IconGoldMedal;
